import { comMapping } from "../../../../util/Function/comMapping"
import configHttp from '../../../../../../configHttp.js'

export function getdata() {
	let obj = {
		formdata: {
			generateType: "",
			reportType: "",

		},
		formlist: [{
				prop: "generateType",
				label: "模板生成类型",
				type: "select",
				selectval: [{
						value: '0',
						label: 'pdf'
					},
					{
						value: '1',
						label: 'excel'
					}
				],
				isnotnull: true,
			},
			{
				prop: "reportType",
				label: "报表类型",
				type: "select",
				selectval: configHttp.projectType == 'Amat' ? comMapping.$amat_bblx : comMapping.$bblx,
				isnotnull: true,
			},
		]
	}
	return obj
}
